<template>
  <v-text-field
    :label="label"
    :error-messages="errorMessages"
    :value="inner"
    type="datetime-local"
    @input="doInput"
  />
</template>

<script>
import moment from 'moment'
export default {
  props: ['value', 'label', 'errorMessages'],
  computed: {
    inner() {
      if (this.value) {
        const date = moment(this.value)
        return date.local().format('YYYY-MM-DDTHH:mm')
      } else {
        return null
      }
    },
  },
  methods: {
    doInput(evt) {
      if (evt) {
        const time = new Date(evt).toISOString()
        this.$emit('input', time)
      } else {
        this.$emit('input', null)
      }
    },
  },
}
</script>
